export const config = {
  global_search: {
    visibility: false,
  },
  show_refresh_button: false,
  show_reset_button: false,
  pagination: false,
  pagination_info: false,
  selected_rows_info: false,
  highlight_row_hover: true,
  highlight_row_hover_color: "#cad5e0",
  rows_selectable: false,
  multi_column_sort: false,
  card_mode: false,
  preservePageOnDataChange: true,
};